import { createStore } from "vuex";
import { menu, getPerssion } from "../api/common";
import session from "@/utils/storage/session.js";
import { Key, Cookie } from "@/utils/storage/cookie";
import { setRouterAddrs } from "../router/index";
export default createStore({
  state: {
    //是否初始化菜单
    init: false,
    customizeLibid: ["JKQT"],
    myObj: {},
    //菜单资源树存放
    menusSourceTree: [],
    menuSourceList: [],
    //按钮名称用于权限控制
    buttonEnameSet: [],
    //路由地址集合
    routerAddrSet: [],
    // 权限路由
    routSet: [],
    //模块对应的按钮权限页面id
    pageId: "",
    replaceStr: "tmkj12",
    loginBookSearch: [],
    // 已打开动态路由数据
    routerData: [],
    // 选中的行数据
    selecteList: [],
    // 菜单栏是否展开
    isCollapsed: false,
    activityTypeData: {},
    fontSize: "中",
    fontSizeMap: [
      { size: "大", base: 18, scale: 1.3 },
      { size: "中", base: 16, scale: 1.15 },
      { size: "小", base: 14, scale: 1 },
    ],
    //路由参数保存
    routerParamsQK: {},
  },
  getters: {
    // 判断一个 libid 是否在自定义列表中
    isCustomizeLib: (state) => (libid) => {
      return state.customizeLibid.includes(libid);
    },
  },
  mutations: {
    // 设置路由参数
    SET_ROUTER_PARAMS_QK(state, payload) {
      state.routerParamsQK = payload;
    },
    SET_MENUS_SOURCE: (state, data) => {
      state.init = true;
      state.menusSourceTree = data.treeList || [];
      state.menuSourceList = data.menuList || [];
      state.buttonEnameSet = data.buttonSet || [];
      state.routerAddrSet = data.routerAddr || [];
      state.routSet = data.routSet || [];
      session.set("routerAddrSet", data.routerAddr);
      session.set("routSet", data.routSet);
      session.set("menusSourceTree", data.treeList);
      session.set("menuSourceList", data.menuList);
      session.set("buttonEnameSet", data.buttonSet);
    },
    SET_PAGE_ID: (state, data) => {
      session.set("pageId", data);
      state.pageId = data;
    },
    SET_BUTTON_LIST: (state, data) => {
      state.buttonEnameSet = data || [];
      session.set("buttonEnameSet", data);
    },
    // 清空
    RESET_STATE: (state) => {
      state.init = false;
      state.menusSourceTree = [];
      state.menuSourceList = [];
      state.buttonEnameSet = [];
      state.routerAddrSet = [];
      state.routSet = [];
      state.pageId = "";
    },

    LOGIN_BOOK_SEARCH: (state, data) => {
      session.set("loginBookSearch", data);
      state.loginBookSearch = data;
    },
    //替换tmkj12的方法
    replaceStringInObject(state, obj) {
      for (const key in obj) {
        if (
          obj[key] &&
          typeof obj[key] === "string" &&
          obj[key].includes(state.replaceStr)
        ) {
          obj[key] = obj[key].replace(state.replaceStr, "");
        }
      }
    },
    setMyObj(state, payload) {
      // 判断payload是否存在且为不为空
      if (!payload || Object.keys(payload).length === 0) {
        //payload 不存在或是空对象
        state.myObj = {};
        console.log(state.myObj);
      } else {
        // 存在且不为空
        state.myObj = payload;
      }
    },

    SET_IS_COLLAPSED(state, payload) {
      state.isCollapsed = payload;
    },
    setRouterData(state, data) {
      state.routerData = data;
    },
    pushRouterData(state, item) {
      state.routerData.push(item);
    },
    removeRouterData(state, path) {
      state.routerData = state.routerData.filter((e) => e.path !== path);
    },
    updateSelecteList(state, data) {
      state.selecteList = data;
    },
    setActivityTypeData(state, data) {
      console.log("进入setActivityTypeData");

      state.activityTypeData = data;
    },
    SET_FONT_SIZE(state, size) {
      state.fontSize = size;
      // switch (size) {
      //   case "大":
      //     state.fontSize = "大";
      //     break;
      //   case "中":
      //     state.fontSize = "中";
      //     break;
      //   case "小":
      //     state.fontSize = "14px";
      //     break;
      // }

      const config = state.fontSizeMap.find((item) => item.size === size);
      if (!config) return;

      /*   // 检测系统缩放比例
      const zoomRatio = window.devicePixelRatio || 1;
      // 实际计算字体大小（自动根据缩放比调节）
      const targetFontSize = (config.base / zoomRatio).toFixed(2);*/

      // ✅ 以 1920 作为基准宽度，根据实际窗口宽度动态调整比例
      const baseWidth = 1920;
      const currentWidth = window.innerWidth;

      // 计算缩放比例（例如 2560px 会是 2560/1920 = 1.33）
      const scale = Math.min(currentWidth / baseWidth, 1.5); // 限制最大放大比例防止过大
      const targetFontSize = (config.base * scale).toFixed(2);

      // 1. 更新 CSS 变量（全局使用）
      document.documentElement.style.setProperty(
        "--font-size-base",
        `${targetFontSize}px`
      );

      // 2. 添加平滑过渡（JavaScript动画）
      const root = document.documentElement;
      let startSize = parseFloat(root.style.fontSize) || 16; // 当前字体大小
      let targetSize = parseFloat(targetFontSize); // 目标字体大小

      // 使用 requestAnimationFrame 实现平滑过渡
      const duration = 300; // 过渡时间（毫秒）
      const startTime = performance.now();

      function animate(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // 0 到 1

        // 使用缓动函数（easeInOutQuad）让过渡更自然
        const easeProgress = progress * progress * (3 - 2 * progress);
        const currentSize = startSize + (targetSize - startSize) * easeProgress;

        root.style.fontSize = `${currentSize}px`;

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      }

      requestAnimationFrame(animate);

      // 3. 保存到本地存储
      localStorage.setItem("app-font-size", size);
    },
  },
  actions: {
    //获取用户相应权限的菜单按钮资源
    GetUserMenuSource({ commit }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const userInfo = Cookie.get(Key.userinfo);
          menu({ userId: userInfo ? JSON.parse(userInfo)?.id : null })
            .then((response) => {
              //将后台查询的路由地址信息动态加载
              if (response.data.treeList.length > 0) {
                response.data.routerAddr = setRouterAddrs(
                  response.data.treeList
                );
              }
              // 获取到了, 将菜单和按钮数据保存到vuex状态
              commit("SET_MENUS_SOURCE", response.data);
              resolve(response); // 正常响应钩子
            })
            .catch((error) => {
              reject(error);
            });
        }, 100);
      });
    },
    setMyObj({ commit }, payload) {
      commit("setMyObj", payload);
    },
    // 获取页面按钮权限id
    loginBookSearch({ commit }, data) {
      commit("LOGIN_BOOK_SEARCH", data);
    },
    // 获取页面按钮权限id
    getPageId({ commit }, data) {
      commit("SET_PAGE_ID", data);
    },
    getButtonEnameSet({ commit }) {
      getPerssion({ userId: JSON.parse(Cookie.get(Key.userinfo)).id }).then(
        (res) => {
          commit("SET_BUTTON_LIST", res.data.buttonSet);
        }
      );
    },
    resetState({ commit }) {
      commit("RESET_STATE");
    },
    //
    replaceStringInObject({ commit }, obj) {
      commit("replaceStringInObject", obj);
    },
  },
  modules: {},
});
